import type { TSerializedWidget } from 'src/entities/workspace/types';
import type {
  TVideobroadcastSerializedInternalState,
  VideobroadcastWidgetEntity,
} from 'src/pages/dashboard/features/videobroadcast-widget/VideobroadcastWidget.entity';

export function serializeVideobroadcastWidget(widget: VideobroadcastWidgetEntity): TSerializedWidget {
  const internalState: TVideobroadcastSerializedInternalState = {
    wellId: widget.wellId,
    stateParams: {
      aspectRatio: widget.stateParams.aspectRatio,
      camerasOrder: widget.stateParams.camerasOrder,
      selectedCameras: widget.stateParams.selectedCameras,
      playAll: widget.stateParams.playAll,
      playbackMode: widget.stateParams.playbackMode,
      playbackTimeMs: widget.stateParams.playbackTimeMs,
      playerSettingsByCameraId: widget.stateParams.playerSettingsByCameraId,
      wellboreId: widget.stateParams.wellboreId,
      additionalInfo: widget.stateParams.additionalInfo,
      defaultSelectWellbore: widget.stateParams.defaultSelectWellbore,
    },
  };

  return {
    wellId: widget.wellId,
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    isFullscreen: widget.isFullscreen,
    internalState,
  };
}
